var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000101781657720037180610000001569994752423309742_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.3 115.1",
    style: {
      enableBackground: "new 0 0 86.3 115.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00D0BD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,115.1L35.4,115.1c-17.5,0-32.7-13.2-35.4-30.7L0,84.1l0.5-62.6l50.1,47.8L45,75.1L8.3,40L8,83.5 c2.2,13.5,13.9,23.6,27.4,23.6h0c14.6,0,26.2-12.5,27.4-23.8c0.4-3.3-0.4-6-1-8.1C59.6,67,54.3,62,47.1,55 c-5.8-5.5-12.3-11.8-19.2-21.3c-1.4-2-4.1-5.6-4.2-10.7c-0.2-5.4,2.4-11.6,6.8-16.1C34.6,2.4,40.1,0,45.9,0 c12.3,0,22.3,10.2,22.3,22.8h-8C60.3,14.6,53.8,8,45.9,8c-4.6,0-7.9,2.4-9.8,4.4c-2.8,2.9-4.6,7-4.5,10.3c0.1,2.5,1.3,4.3,2.7,6.3 c6.5,9,12.7,15,18.2,20.2c7.6,7.3,14.1,13.5,17,24c0.7,2.5,1.7,6.2,1.2,11.1C69.2,99.2,54.6,115.1,35.4,115.1L35.4,115.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "78.3,90.4 78.1,38.6 65.7,51.7 59.9,46.2 86.1,18.5 86.3,90.4  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmLogo);
export default __webpack_public_path__ + "static/media/sm-logo.8546d139fde202b40950584adc4780a5.svg";
export { ForwardRef as ReactComponent };